import request from '../../utils/request';
import { Search } from '@/DTOS/LaborExtra/Search';

const LaborExtraService = {
  search: (search: Search) => {
    return request('/laborExtra/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    /** @type {{ name: any; isActive: any; }} */ formData: {
      name: any;
      isActive: any;
    }
  ) => {
    return request('/laborExtra/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          name: formData.name,
          isActive: formData.isActive,
        },
      }),
    });
  },
};

export default LaborExtraService;
